

















import Component, { mixins } from "vue-class-component";
import { Currency } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";
import WithCurrency from "@/mixins/WithCurrency";
import WithLoadingStatus from "@/mixins/WithLoadingStatus";
import WrapperCheckAuthorities from "@/components/WrapperCheckAuthorities.vue";
import BaseSlowConnection from "@/components/BaseSlowConnection";
import BlockPaymentSystemAdd from "./components/BlockPaymentSystemAdd.vue";
import BlockPaymentSystemAddSelector from "./components/BlockPaymentSystemAddSelector.vue";

@Component({
  name: "PaymentsRightCol",
  components: {
    BlockPaymentSystemAdd,
    WrapperCheckAuthorities,
    BlockPaymentSystemAddSelector,
    BaseSlowConnection,
  },
})
export default class PaymentsRightCol extends mixins(WithCurrency, WithLoadingStatus) {
  public isLoading: boolean = true;

  public show: boolean = false;

  public currencyList: Currency[] = [];

  public type: string = "";

  public showCreate({ type }: { type: string }) {
    this.type = type;
    this.show = true;
  }

  public systemAdded() {
    this.show = false;
  }

  public created() {
    this.loadingStatusShow([
      this.currencyFindAll().then((response: Currency[]) => {
        this.currencyList = response;
      }),
    ]).then(() => {
      this.isLoading = false;
    });
  }
}
